import { AppState } from '../../../core/Store';
import { State } from './reducer';

type Selector<T = any> = (redState: State, appState: AppState) => T;
function prepareSelector<T>(selector: Selector<T>) {
	return (state: AppState) => {
		return selector(state.ui.mobileSummaryModal, state);
	};
}

export const getModalOpen = prepareSelector((redState, appState) => {
	return redState.modalOpen;
});
